<template>
   <dt class="sr-only">{{ field.label }}</dt>
   <dd>
      <OnOffToggle
         id="comm-pref-marketing"
         data-cy="account-profile-marketing-preferences"
         :description="field.label"
         :value="receiveMarketingEmails"
         :labelOn="$t('system.toggle.yes')"
         :labelOff="$t('system.toggle.no')"
         :isDisabled="isLoading"
         @input="toggleCommsMarketing"
      />
   </dd>
</template>

<script setup lang="ts">
import { useToastKey } from "@/plugins/useToast";
import { useUserStore } from "@/stores/userStore";
import type { AccountProfileField } from "../accountTypes";

// Declarations
// -----------------------------------------
const useToast = inject(useToastKey);
const $t = useI18n().t;
const userStore = useUserStore();

const props = defineProps<{
   field: AccountProfileField;
}>();

// State
const receiveMarketingEmails = ref<boolean>(userStore.user.notifications);
const isLoading = ref(false);

// Methods
// -----------------------------------------
async function toggleCommsMarketing() {
   try {
      isLoading.value = true;
      const newCommsPreference = !receiveMarketingEmails.value;
      await userStore.updateCommsPreference("marketing", newCommsPreference);
      receiveMarketingEmails.value = newCommsPreference;
   } catch (error) {
      console.error("Error updating user communication marketing preference: ", error);

      useToast({
         position: "top-end",
         text: $t("system.errors.error_update"),
         type: "error",
      });
   } finally {
      isLoading.value = false;
   }
}
</script>
